import data from "../../utils/constants/data.json";
import CommonComponent from "../common-component/CommonComponent";

const EducationComponent = () => {
    const { educationData } = data;

    const educationLayout = <CommonComponent items={educationData} />;

    return educationLayout;
};

export default EducationComponent;
